import React, { Component } from 'react'
import { useNavigate } from 'react-router-dom'

class ErrorBoundary extends Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false }
    }
    static getDerivedStateFromError() {
        return { hasError: true }
    }
    componentDidCatch(error, errorInfo) {
        console.error("uncaught error:", error, errorInfo)
    }
    componentDidUpdate() {
        if (this.state.hasError) this.props.navigate('/')
    }
    render() {
        if (this.state.hasError) return null
        return this.props.children
    }
}

export function ErrorBoundaryWithNavigate(props) {
    const navigate = useNavigate()
    return <ErrorBoundary {...props} navigate={navigate} />
}
